import type { Epic } from '../../index.js'
import { exhaustMap, withLatestFrom } from 'rxjs/operators'
import { otuSlice } from '../../Slice/Otu/OtuSlice.js'
import { catchError, defer, filter, map, of, takeUntil } from 'rxjs'
import { AUTOCOMPLETE_PAGE_SIZE } from '../../../Repository/Otu/OtuRepository.js'

export const FetchNextEpic: Epic = (action$, state$, { OtuRepository, [otuSlice.name]: otu }) =>
  action$.pipe(
    filter(otu.fetchMore.match),
    withLatestFrom(state$),
    // catchError stays inside the exhaustMap — on the outer stream one failure completes the epic for good.
    // `defer` puts the request construction inside it too, so a synchronous throw is caught as well.
    exhaustMap(([action, state]) =>
      defer(() =>
        OtuRepository.autocompleteOrder({
          orderId: action.payload.orderId,
          projectId: action.payload.projectId,
          query: action.payload.query,
          field: action.payload.field,
          // A page index, not an offset — the endpoint multiplies it by the page size.
          page: Math.floor(state.otu.results.length / AUTOCOMPLETE_PAGE_SIZE),
          blastType: action.payload.blastType
        })
      ).pipe(
        takeUntil(action$.pipe(filter(otu.fetchInitial.match))),
        map((response) => otu.fetchMoreSuccess(response)),
        catchError((error) => of(otu.fetchMoreFailure(error)))
      )
    )
  )
